import React, { Component } from 'react';
import { indPayment, indVerifyLink } from '../../API/FetchCall';
import $ from 'jquery';
import { indComSignup, indUploadDocs } from '../../API/FetchCall';
import SimpleReactValidator from 'simple-react-validator';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import { BASEURL } from '../../constant';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

import Geocode from "react-geocode";
Geocode.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
Geocode.setLanguage("en");
Geocode.setRegion("es");
Geocode.enableDebug();
class IndividualComplete extends Component {

  constructor(props) {
    super(props);

    this.state = {
      uploaded: 0,
      partner_id: this.props.match.params.id,
      token: this.props.match.params.token,
      partner_name: '',
      btnDisable: false,
      user_name: '',
      email_address: '',
      idproof: '',
      qualification: '',
      user_image: '',
    }
    this.verifyPage();
    // $('.selectpicker').selectpicker('refresh');
    this.validator = new SimpleReactValidator();
  }
  verifyPage() {
    let data = JSON.stringify({
      login_id: this.props.match.params.id,
      token: this.props.match.params.token,
    });
    let toastr;
    indVerifyLink(data).then((response) => {
      if (response.status === 0) {
        toastr = window.toastr.error; //warning
        let err = response.errors ? response.errors[0].msg : response.message;
        toastr(err, {
          positionClass: "toast-bottom-right",
          containerId: "toast-bottom-right",
        });
        this.props.history.push("/login");
      } else {
        this.setState({
          partner_name: response.data.partner_name,
          email_address: response.data.email_id,
          user_name: response.data.user_name,
          uploaded: response.uploaded,
        });
      }
    })
  }
  componentDidUpdate() {
  }
  componentDidMount() {
  }
  handleFile = (e) => {
    const propName = e.target.name;
    const files = e.target.files[0];
    this.setState({ [propName]: files });
  };
  handleSubmit = (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({
        btnDisable: true
      });
      const uploaded = this.state.uploaded;
      let doc_name = '';
      if (uploaded == 0)
        doc_name = 'idproof';
      if (uploaded == 1)
        doc_name = 'qualification';
      if (uploaded == 2)
        doc_name = 'user_image';
      // 
      let req = {
        [doc_name]: this.state[doc_name],
        token: this.state.token,
        partner_id: this.state.partner_id,
        partner_name: this.state.partner_name,
        email_address: this.state.email_address,
        user_name: this.state.user_name,
        uploaded: uploaded,
      }
      if (uploaded == 2) {
        indComSignup(req).then(res => {
          let toastr = '';
          this.setState({
            btnDisable: false
          });
          if (res.status === 1) {
            toastr = window.toastr.success;
            toastr('', `Successfully Uploaded, if there are any irregularities in the submitted 
            documents, our team will get in touch with you soon`, {
              positionClass: "toast-bottom-right",
              containerId: "toast-bottom-right"
            });
            setTimeout(function () {
              window.location.href = res.redirect;
            }, 2000);
          } else {
            let er = res.message
            toastr = window.toastr.error; //warning
            toastr(er, toastr, {
              positionClass: "toast-bottom-right",
              containerId: "toast-bottom-right"
            });
          }
        })
      } else {

        indUploadDocs(req).then(res => {
          let toastr = '';
          this.setState({
            btnDisable: false
          });
          if (res.status === 1) {
            this.setState({
              uploaded: res.uploaded
            })
            toastr = window.toastr.success;
            toastr('', `Successfully Uploaded, if there are any irregularities in the submitted 
          document, our team will get in touch with you soon, Please Upload Next Documents`, {
              positionClass: "toast-bottom-right",
              containerId: "toast-bottom-right"
            });
          } else {
            let er = res.message
            toastr = window.toastr.error; //warning
            toastr(er, toastr, {
              positionClass: "toast-bottom-right",
              containerId: "toast-bottom-right"
            });
          }
        })
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }
  render() {
    this.validator.purgeFields();
    const { uploaded } = this.state;
    return (
      <div className="container-fluid">
        <form>
          <div className="row">
            <div className="col-md-6 col-sm-6 sign-bg-login   hidden-xs">
              <div className="shadow-bg"></div>
              <h1>
                Welcome to
                <br /> BeWise Partner Program
              </h1>
            </div>
            <div className="col-md-6 col-sm-6 signup-right">
              <div className="inner-right">
                <div className="row">
                  <div className="col-md-12 col-sm-12">
                    <div className="right-logo">
                      <a href='/individual'>
                        <img src="/assets/images/bewiselogo.png" />
                      </a>
                    </div>
                    <form onSubmit={this.handleSubmit}>
                      <div>
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>ID Proof <span class="astrick">*</span>
                                {uploaded > 0 && <span className='uploaded'><i class="fa fa-check" aria-hidden="true"></i></span>}
                              </label>
                              <div className="custom-select-drop dropdown">
                                <input
                                  type="file"
                                  name="idproof"
                                  onChange={this.handleFile}
                                  className="form-control mar-btm"
                                  accept="image/png, image/gif, image/jpeg,application/pdf"
                                />
                                {uploaded == 0 && this.validator.message('ID Proof File', this.state.idproof, 'required', { className: 'text-danger' })}
                              </div>
                            </div>
                          </div>
                          {uploaded == 0 && (
                            <div className="col-lg-6 col-md-12">
                              <div className="form-group">
                                <div className="custom-select-drop dropdown">
                                  <button className="btn orange-btn" type='submit' disabled={this.state.btnDisable}>Upload</button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>Highest Qualification <span class="astrick">*</span>
                                {uploaded > 1 && <span className='uploaded'><i class="fa fa-check" aria-hidden="true"></i></span>}
                              </label>
                              <div className="custom-select-drop dropdown">
                                <input
                                  type="file"
                                  name="qualification"
                                  onChange={this.handleFile}
                                  className="form-control mar-btm"
                                />
                                {uploaded == 1 && this.validator.message('Qualification File', this.state.qualification, 'required', { className: 'text-danger' })}
                              </div>
                            </div>
                          </div>
                          {uploaded == 1 && (
                            <div className="col-lg-6 col-md-12">
                              <div className="form-group">
                                <div className="custom-select-drop dropdown">
                                  <button className="btn orange-btn" type='submit' disabled={this.state.btnDisable}>Uplaod</button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-md-12">
                            <div className="form-group">
                              <label>Your Photograph <span class="astrick">*</span>
                                {uploaded > 2 && <span className='uploaded'><i class="fa fa-check" aria-hidden="true"></i></span>}
                              </label>
                              <div className="custom-select-drop dropdown">
                                <input
                                  type="file"
                                  name="user_image"
                                  onChange={this.handleFile}
                                  className="form-control mar-btm"
                                />
                                {uploaded == 2 && this.validator.message('Photograph File', this.state.user_image, 'required', { className: 'text-danger' })}
                              </div>
                            </div>
                          </div>
                          {uploaded == 2 && (
                            <div className="col-lg-6 col-md-12">
                              <div className="form-group">
                                <div className="custom-select-drop dropdown">
                                  <button className="btn orange-btn" type='submit' disabled={this.state.btnDisable}>Submit</button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div >
    )
  }
}

export default IndividualComplete;


// WEBPACK FOOTER //
// ./src/components/SignUp/individual_complete.jsx